export enum GLOBAL_DATA_KEY {
    corpCd = "corpCd",
    corpPrefix = "corpPrefix",
    officeCd = "officeCd",
    officeSelected = "officeSelected",
    staffInfo = "staffInfo",
    userInfo = "userInfo",
    staffCd = "staffCd",
    officeVersion = "officeVersion"
}